var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-search',
                        view: publicPath + 'sprite.svg#view-icon-search',
                        viewBox: '0 0 15 15',
                        title: 'Icon / Search',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };